module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/2/4-9e56e5987e557d9a33152a6e779c1049.jpg";